import locationAssign from './locationAssign';
import locationReplace from './locationReplace';
import reduxReplace from './reduxReplace';

export const LOGIN_URL = '/login';

export default function redirect(href) {
  const regex = new RegExp(LOGIN_URL);
  if (global.BROWSER) {
    if (regex.test(href)) {
      locationReplace(href);
    } else {
      locationAssign(href);
    }
  } else {
    reduxReplace(href);
  }
}
